module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/source-map-loader!./src/assets/script.js
// module id = 374
// module chunks = 4